import clsx from 'clsx';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

/** 统一空态（插画位 + 说明 + 主行动）。 */
export function EmptyState({ title, description, action, className }: EmptyStateProps): JSX.Element {
  return (
    <div className={clsx('flex flex-col items-center justify-center gap-3 py-12 text-center', className)}>
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-panel-2 text-2xl text-dim" aria-hidden>
        ◌
      </div>
      <p className="text-sm font-medium text-text">{title}</p>
      {description ? <p className="max-w-[280px] text-xs text-dim">{description}</p> : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
